import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { ApiClient, ApiClientWithAuth } from '@/services/api/client'
import { CookieService } from '@/services/cookie'
import { log } from '@/util/log'
import { Either, left, right } from 'fp-ts/lib/Either'

export class UsualPowerService {
  constructor (
    private readonly apiClient: typeof ApiClient = ApiClientWithAuth
  ) {}
  async getUserInfo(): Promise<Either<Error, UsualPower>> {
    const target = `/api/user/usual_power/current_user`

    try {
      const response = await this.apiClient.get(target)

      log.debug({ service: target, response })

      return right(response.body.data)
    } catch (error) {
      log.error({ service: target, error })

      return left(error)
    }
  }
  async update(leftPathname: string, rightPathname: string): Promise<Either<Error, null>> {
    const target = `/api/user/usual_power/update`

    try {
      const response = await this.apiClient
        .post(target, {
          leftPathname,
          rightPathname,
        })

      log.debug({ service: target, response })

      return right(response.body)
    } catch (error) {
      log.error({ service: target, error })

      return left(error)
    }
  }
}

export interface UsualPower {
  leftPathname?: string,
  rightPathname?: string
}

interface CreateUsualPowerServiceDep {
  getIsConfigEnabled: (brandName: string | null) => boolean
  getIsRegisteredUser: () => boolean
}
const defaultUsualPowerServiceDep: CreateUsualPowerServiceDep = {
  getIsConfigEnabled: (brandName: string | null) => BehaviorConfig.createFromBrand(brandName).usualPower.enabled,
  getIsRegisteredUser: () => CookieService.isRegistered(),
}

export function createUsualPowerGetService(
  brandEnglishName: string | null,
  dep: CreateUsualPowerServiceDep = defaultUsualPowerServiceDep
): Pick<UsualPowerService, 'getUserInfo'> {
  const enabled = dep.getIsConfigEnabled(brandEnglishName) && dep.getIsRegisteredUser()
  if (enabled) {
    return new UsualPowerService()
  }

  log.debug('create disabled usual power service')

  return { getUserInfo: async () => right({}) }
}
